export enum IconNames {
    Help = 'help',
    AccountCircle = 'account_circle',
    Elipses = 'more_vert'
}